import { ENV } from "@wb/env/env";
import { isServer } from "@wb/env/isServer";
import { env } from "std-env";

export const isStage = (): boolean => {
  if (env.FORCE_STAGE === "true") {
    return true;
  }

  if (isServer()) {
    return env.VERCEL_TARGET_ENV === ENV.STAGE || env.TARGET_ENV === ENV.STAGE;
  }

  return (
    env.NEXT_PUBLIC_VERCEL_TARGET_ENV === ENV.STAGE ||
    globalThis.location?.hostname.includes("stage")
  );
};
